import React from 'react';

const Pvt = () => {
  return (
    <div className="bg-gray-50 py-10 px-4 min-h-screen">
      <div className="max-w-5xl mx-auto p-6 sm:p-10">
        {/* Title */}
        <h1 className="text-3xl sm:text-4xl font-bold text-[#b7b7a1] mb-6">
          Private Limited Company Registration Services
        </h1>

        {/* Introduction */}
        <div className="space-y-4 text-gray-700 leading-relaxed mb-10">
          <p>
            Our experienced legal and tax consultants are dedicated to assisting customers in the
            comprehensive process of registering a Private Limited Company, starting with the critical
            task of checking the availability of the desired company name. We ensure that the proposed
            name complies with regulatory guidelines and is unique, thus preventing any potential
            conflicts.
          </p>
          <p>
            Once the name is confirmed, our experts guide clients through the preparation of necessary
            documentation, including the Memorandum and Articles of Association, and assist in filing all
            required forms with the relevant authorities.
          </p>
          <p>
            With a thorough understanding of corporate regulations and tax implications, we provide
            personalized guidance at every step, ensuring a smooth and efficient registration process.
            Our goal is to equip entrepreneurs with the foundation they need to successfully launch their
            private limited companies, paving the way for future growth and compliance.
          </p>
        </div>

        {/* Registration Process */}
        <h2 className="text-2xl font-semibold text-[#b7b7a1] mb-4">
          Process of Registering a Private Limited Company in India
        </h2>
        <ol className="list-decimal pl-6 space-y-3 text-gray-800 mb-10">
          <li>
            <strong>Choose a Unique Name:</strong> Must end with "Private Limited" and not duplicate existing names.
          </li>
          <li>
            <strong>Obtain Digital Signature Certificate (DSC):</strong> Required for all directors to sign documents electronically.
          </li>
          <li>
            <strong>Obtain Director Identification Number (DIN):</strong> Mandatory for each director before incorporation.
          </li>
          <li>
            <strong>Prepare Required Documents:</strong> Includes MOA, AOA, ID/address proofs, and office address documents.
          </li>
          <li>
            <strong>File for Incorporation:</strong> Submit SPICe form and documents via the MCA portal.
          </li>
          <li>
            <strong>Payment of Fees:</strong> Based on authorized share capital; paid online.
          </li>
          <li>
            <strong>Certificate of Incorporation:</strong> Issued by the Registrar of Companies upon approval.
          </li>
          <li>
            <strong>Apply for PAN and TAN:</strong> Essential for taxation and compliance.
          </li>
          <li>
            <strong>Open a Bank Account:</strong> Dedicated business bank account in company’s name.
          </li>
          <li>
            <strong>Maintain Compliance:</strong> Conduct AGMs, maintain records, and file annual returns.
          </li>
        </ol>

        {/* Necessity of Registration */}
        <h2 className="text-2xl font-semibold text-[#b7b7a1] mb-4">
          Necessity of Registering a Private Limited Company in India
        </h2>
        <ul className="list-disc pl-6 space-y-3 text-gray-800 mb-10">
          <li><strong>Legal Recognition:</strong> Separate legal entity with contractual rights.</li>
          <li><strong>Limited Liability Protection:</strong> Personal assets are protected.</li>
          <li><strong>Credibility and Trust:</strong> Enhances brand image with stakeholders.</li>
          <li><strong>Access to Funding:</strong> Easier to attract investors and raise capital.</li>
          <li><strong>Tax Benefits:</strong> Eligible for tax incentives and deductions.</li>
          <li><strong>Compliance Requirements:</strong> Encourages lawful operation and reputation management.</li>
        </ul>

        {/* Digital Signatures */}
        <h2 className="text-2xl font-semibold text-[#b7b7a1] mb-4">
          Importance of Digital Signatures in Company Registration
        </h2>
        <ul className="list-disc pl-6 space-y-3 text-gray-800">
          <li><strong>Authentication:</strong> Verifies identity and ensures authorized access.</li>
          <li><strong>Legal Validity:</strong> Recognized under the Information Technology Act in India.</li>
          <li><strong>Efficiency:</strong> Speeds up document processing and submission.</li>
          <li><strong>Ease of Use:</strong> Allows remote signing from anywhere in the world.</li>
          <li><strong>Secure Transaction:</strong> Uses encryption to protect document integrity.</li>
          <li><strong>Mandatory Requirement:</strong> Required for submitting e-forms on the MCA portal.</li>
          <li><strong>Cost-Effectiveness:</strong> Reduces physical paperwork and courier costs.</li>
        </ul>
      </div>
    </div>
  );
};

export default Pvt;
